import React from 'react';

import { HeaderManager } from 'inside-out/managers/headerManager';
import { Link, goBack } from 'inside-out/components/shared/link';

import logo from 'inside-out/images/logo.svg';
import logoMobile from 'inside-out/images/logo-mobile.svg';
import ArrowIcon from 'inside-out/components/shared/icons/arrowIcon';
import ArrowIconLarge from 'inside-out/components/shared/icons/arrowIconLarge';
import {
	wrapperStyle,
	innerWrapperStyle,
	headerStyle,
	logoAndBackStyle,
	backArrowStyle,
	logoLinkStyle,
	logoStyle,
	subheaderStyle,
	ctaStyle,
} from './headersimple.styles';

import { aqua } from 'inside-out/global-styles';

export class HeaderSimple extends React.PureComponent {
	state = {
		back: true,
		subheader: null,
		cta: null,
	};

	componentDidMount = () => {
		HeaderManager.subscribe(this.handleStateUpdate);
	};

	componentWillUnmount = () => {
		HeaderManager.unsubscribe(this.handleStateUpdate);
	};

	handleStateUpdate = newState => {
		this.setState(newState);
	};

	render() {
		const { subheader, cta, back } = this.state;

		return (
			<div data-component="HeaderSimple" className={wrapperStyle}>
				<div className={innerWrapperStyle}>
					<div className={logoAndBackStyle(back)}>
						{back && (
							<span className={backArrowStyle}>
								<a onClick={goBack}>
									<ArrowIconLarge fill={aqua} width={24} height={24} />
								</a>
							</span>
						)}
						<div className={headerStyle}>
							<Link to="/" className={logoLinkStyle}>
								<span className={logoStyle}>
									<img
										id="logoDesktop"
										src={logo}
										alt="Inside Out : Institute for Eating Disorders"
									/>
									<img
										id="logoMobile"
										src={logoMobile}
										alt="Inside Out : Institute for Eating Disorders"
									/>
								</span>
							</Link>
							{subheader && <p className={subheaderStyle}>{subheader}</p>}
						</div>
					</div>
					{cta && (
						<div className={ctaStyle}>
							{cta.question && <p>{cta.question}</p>}
							<Link to={cta.callToAction.to}>
								{cta.callToAction.name} <ArrowIcon fill="inherit" />
							</Link>
						</div>
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/headerSimple/headersimple.component.js